"use strict";
// ToDo: Remove this file
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLegacyForm = exports.readonlyFormConfig = exports.filterDisabledData = void 0;
/* eslint-disable react-hooks/exhaustive-deps */
const react_1 = require("react");
const ValidationErrors_1 = require("../../components/ValidationErrors");
const object_1 = require("../../utils/object");
const useFormField = (initValue, resetError, required = false, onChangeCallback, modifiers, disabled = false, hidden = false) => {
    const [field, setField] = (0, react_1.useState)(initValue);
    const [meta, setMeta] = (0, react_1.useState)();
    const onChange = (0, react_1.useCallback)((v, d) => {
        resetError();
        setField(v);
        setMeta(d);
    }, [setField, setMeta]);
    (0, react_1.useEffect)(() => {
        onChangeCallback === null || onChangeCallback === void 0 ? void 0 : onChangeCallback(field, meta);
    }, [field, meta]);
    const onEvent = (0, react_1.useCallback)((e, d) => {
        if (e.target.type === 'checkbox' && 'checked' in e.target) {
            onChange(e.target.checked, d);
        }
        else {
            const value = e.target.value;
            onChange(value, d);
        }
    }, [onChange]);
    const mod = (0, react_1.useMemo)(() => {
        const result = new Set(modifiers !== null && modifiers !== void 0 ? modifiers : []);
        if (required)
            result.add('required');
        return Array.from(result);
    }, [required, modifiers]);
    return {
        value: field,
        meta,
        setValue: onChange,
        setMeta,
        required,
        onEvent,
        modifiers: mod,
        disabled,
        hidden,
        resetError,
    };
};
const filterDisabledData = (data, config) => {
    const filterFunction = (entry) => {
        const key = entry[0];
        return !(config[key].hidden || config[key].disabled);
    };
    return (0, object_1.filterObject)(data, filterFunction);
};
exports.filterDisabledData = filterDisabledData;
const readonlyFormConfig = (config) => {
    const result = (0, object_1.mapObject)(config, ([_, value]) => ({
        ...value,
        disabled: true,
    }));
    return result;
};
exports.readonlyFormConfig = readonlyFormConfig;
const hasAllValid = (formErrors) => {
    return !Object.keys(formErrors).some((key) => { var _a; return (_a = formErrors[key]) === null || _a === void 0 ? void 0 : _a.length; });
};
/**
 * Don't use it!
 * The code is extremely unstable. APIs, types, performance have problems.
 */
const useLegacyForm = (config, submit, validator = () => ({}), onChangeFromData) => {
    const [formErrors, setFormErrors] = (0, react_1.useState)({});
    const resetFieldError = (0, react_1.useCallback)((fieldName) => {
        setFormErrors((state) => {
            const newState = { ...state };
            if (fieldName in newState) {
                delete newState[fieldName];
                return newState;
            }
            return state;
        });
    }, [formErrors]);
    // Huge miss in stability and performance:
    // It is forbidden to use hooks in arrays.
    // There is no point in a huge number of hooks, the fields must be configured once.
    // Miss api: No value control access, only initialization.
    const fields = Object.keys(config).reduce((acc, key) => {
        var _a, _b, _c, _d, _e;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const error = (0, react_1.useMemo)(() => {
            return formErrors[key];
        }, [formErrors]);
        const resetError = () => {
            resetFieldError(key);
        };
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const formField = useFormField(config[key].initialValue, resetError, !!((_a = config[key]) === null || _a === void 0 ? void 0 : _a.required), (_b = config[key]) === null || _b === void 0 ? void 0 : _b.onChangeCallback, (_c = config[key]) === null || _c === void 0 ? void 0 : _c.modifiers, (_d = config[key]) === null || _d === void 0 ? void 0 : _d.disabled, (_e = config[key]) === null || _e === void 0 ? void 0 : _e.hidden);
        const formFieldObject = {
            ...formField,
            error,
        };
        return {
            ...acc,
            [key]: formFieldObject,
        };
    }, {});
    const validate = () => {
        const formDataWithoutBlankField = Object.fromEntries(Object.entries(formData).filter(entre => !!entre[1]));
        const validateForm = (formData) => {
            const errors = validator(formData);
            return Object.keys(errors).reduce((acc, key) => {
                const fieldError = (0, ValidationErrors_1.getFormError)(errors, key);
                return {
                    ...acc,
                    [key]: fieldError,
                };
            }, {});
        };
        const errors = validateForm(formDataWithoutBlankField);
        setFormErrors(errors);
        return hasAllValid(errors);
    };
    const formData = (0, react_1.useMemo)(() => {
        return Object.keys(fields).reduce((acc, key) => {
            return {
                ...acc,
                [key]: fields[key].value,
            };
        }, {});
    }, [fields]);
    (0, react_1.useEffect)(() => {
        onChangeFromData === null || onChangeFromData === void 0 ? void 0 : onChangeFromData(formData);
    }, [onChangeFromData, formData]);
    const isValid = (0, react_1.useMemo)(() => {
        return hasAllValid(formErrors);
    }, [formErrors]);
    const onSubmit = () => {
        const valid = validate();
        if (valid)
            submit(formData);
    };
    const eventToValue = (handleValue) => ((e) => (handleValue(e.target.value)));
    const resetFormErrors = () => {
        setFormErrors({});
    };
    return {
        resetFormErrors,
        fields,
        formData,
        onSubmit,
        isValid,
        // deprecated
        eventToValue,
        validate,
    };
};
exports.useLegacyForm = useLegacyForm;
//# sourceMappingURL=legacy.js.map